/**
 * Mixin de scroll depth — rastreia a profundidade máxima de scroll (25/50/75/100%).
 * Inclua em qualquer componente de página que precise desse tracking.
 */
import { trackScrollDepth } from '@/utils/lpTracker';

// Nota: Vue 2 não faz proxy de propriedades com prefixo "_" no data().
// Por isso usamos nomes sem underscore.
const scrollHandlers = new WeakMap();
const scrollMarcadores = new WeakMap();

export default {
  mounted() {
    scrollMarcadores.set(this, new Set());
    const handler = () => {
      const scrolled   = window.scrollY + window.innerHeight;
      const total      = document.documentElement.scrollHeight;
      const percentual = Math.round((scrolled / total) * 100);
      const marcadores = scrollMarcadores.get(this);

      for (const marca of [25, 50, 75, 100]) {
        if (percentual >= marca && !marcadores.has(marca)) {
          marcadores.add(marca);
          trackScrollDepth(marca);
        }
      }
    };
    scrollHandlers.set(this, handler);
    window.addEventListener('scroll', handler, { passive: true });
  },

  beforeDestroy() {
    const handler = scrollHandlers.get(this);
    if (handler) window.removeEventListener('scroll', handler);
  },
};
